export const urls = {
  api: process.env.VUE_APP_API_ENDPOINT_URL,
  app: process.env.VUE_APP_URL
}
